export const PACK_BOOKING_WIZARD_HINT =
  "This looks like a pack booking sheet. Use Import Campaign (By Pack).";

export const FORMAT_MATRIX_WIZARD_HINT =
  "This doesn't look like a pack booking sheet. Use Import Campaign (By Format) for a Master Install List.";

export function adviceForImportAnalyseError(message: string): string | null {
  const lower = message.toLowerCase();
  if (lower.includes("master install list")) return PACK_BOOKING_WIZARD_HINT;
  if (lower.includes("campaign and pack columns")) return FORMAT_MATRIX_WIZARD_HINT;
  return null;
}

export function filenameLooksLikePackBooking(filename: string): boolean {
  return /\bbooking\b/i.test(filename);
}
